<!--队员管理-->
<template>
  <div>
    <div>
      <van-nav-bar
        title="队员管理"
        left-text="返回"
        left-arrow
        @click-left="onTopClickLeft"
      >
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          slot="right"
          style="font-size:20px;"
        >
          <van-icon style="font-size:20px;" name="wap-home" />
        </a>
      </van-nav-bar>
    </div>
    <div style="background: #fff;">
      <div
        style="text-align: center;padding: 10px;font-size: 15px;font-weight: 600;border-bottom: 1px solid #e1e1e1;margin-left: 10px;
    margin-right: 10px;"
      >
        {{ SSMC }}
      </div>
    </div>

    <van-row>
      <div style="margin: 15px;">
        <div style="float:left;font-size:14px">
          <label>队伍信息</label>
        </div>
        <div style="float:right;font-size:14px">
          <label></label>
        </div>
      </div>
    </van-row>
    <div style="margin-top:15px">
      <van-cell title="队伍全称" :value="DWXX.DWQC" />
      <van-cell title="队伍简称" :value="DWXX.DWJC" />
      <van-cell title="领队名称" :value="DWXX.LDXM" />
      <van-cell title="领队电话" :value="DWXX.LDTEL" />
      <!-- <van-cell title="比赛联系人" :value="BSLXR" />
      <van-cell title="比赛联系人电话" :value="BSLXRTEL" /> -->
    </div>

    <van-row>
      <div style="margin: 15px;">
        <div style="float:left;font-size:14px">
          <label>添加信息</label>
        </div>
        <div style="float:right;font-size:14px">
          <label></label>
        </div>
      </div>
    </van-row>

    <div style="margin-top:15px">
      <van-cell
        title="已报名人员"
        :value="'当前' + ZRS + '人'"
        is-link
        @click="openDyInfoHandler"
      />
      <van-cell
        title="请分配组别"
        :value="'已报名' + ZBCOUNT + '个组别'"
        is-link
        @click="openZbShowHandler"
      />
    </div>

    <div style="width:100px;height:156px;"></div>

    <!--底部按钮  开始-->
    <van-tabbar>
      <van-tabbar-item v-if="false"
        ><van-button round type="warning" @click="copyUrl()"
          >邀请队员</van-button
        ></van-tabbar-item
      >
      <van-tabbar-item v-if="false"
        ><van-button round type="primary" @click="reportNavUrl('ldbm')"
          >提交数据</van-button
        ></van-tabbar-item
      >
    </van-tabbar>
    <!--底部按钮  结束-->

    <!-- 已有的队员弹出框  开始 -->
    <van-action-sheet v-model="dwGlShowVisible" title="已有队员管理">
      <div style="background: #F2F2F2;">
        <div style="padding:16px;background: #fff;">
          <van-row>
            <div>
              <div style="float:left;font-size:14px">
                <label
                  >队员（共 {{ MRYLIST.length + WRYLIST.length }} 人）</label
                >
              </div>
              <div
                style="float:right;font-size:14px"
                v-if="ISSF === '0' && ISLDZDZB === 'Y'"
              >
                <van-button type="danger" size="mini" @click="teamDeleteCyxx"
                  >删除队员</van-button
                >
              </div>
            </div>
          </van-row>
        </div>

        <!-- 男生数量  开始 -->
        <div style="padding:16px;">
          <van-row>
            <div>
              <div style="float:left;font-size:14px">
                <label>男（共{{ MRYLIST.length }}人）</label>
              </div>
              <div style="float:right;font-size:14px;display:none">
                <label>点击头像查看详情</label>
              </div>
            </div>
          </van-row>
        </div>

        <div style="background: #fff;">
          <div style="margin-left:10px;margin-right:10px;">
            <van-checkbox-group v-model="selectRyidCheckBoxDatas">
              <van-grid :border="true" :column-num="3">
                <van-grid-item v-for="(item, index) in MRYLIST" :key="index">
                  <div style="position: relative;text-align: center;">
                    <van-checkbox :name="item.RYID">
                      <img
                        :src="item.TXURL"
                        style="width: 2.5rem;height: 2.5rem;border-radius: 100%;"
                      />
                      <p
                        style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;"
                      >
                        {{ item.RYXM }}({{ item.AGE }}岁)
                      </p>
                      <div
                        style="text-align: right;"
                        v-if="ISSF === '0' && ISLDZDZB === 'Y'"
                      >
                        <van-tag type="primary" @click="editorCyHandler(item)"
                          >编辑</van-tag
                        >
                      </div>
                    </van-checkbox>
                  </div>
                </van-grid-item>

                <van-grid-item
                  @click="navToAddRyUrl()"
                  v-if="ISSF === '0' && ISLDZDZB === 'Y'"
                >
                  <img src="../../assets/images/add.png" style="width:30px" />
                </van-grid-item>
              </van-grid>
            </van-checkbox-group>
          </div>
        </div>

        <!-- 男生数量  结束 -->

        <!-- 女生数量  开始 -->
        <div style="padding:16px;">
          <van-row>
            <div>
              <div style="float:left;font-size:14px">
                <label>女（共{{ WRYLIST.length }}人）</label>
              </div>
              <div style="float:right;font-size:14px;display:none">
                <label>点击头像查看详情</label>
              </div>
            </div>
          </van-row>
        </div>

        <div style="background: #fff;">
          <div style="margin-left:10px;margin-right:10px;">
            <van-checkbox-group v-model="selectRyidCheckBoxDatas">
              <van-grid :border="true" :column-num="3">
                <van-grid-item v-for="(item, index) in WRYLIST" :key="index">
                  <div style="position: relative;text-align: center;">
                    <van-checkbox :name="item.RYID">
                      <img
                        :src="item.TXURL"
                        style="width: 2.5rem;height: 2.5rem;border-radius: 100%;"
                      />
                      <p
                        style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;"
                      >
                        {{ item.RYXM }}({{ item.AGE }}岁)
                      </p>
                      <div
                        style="text-align: right;"
                        v-if="ISSF === '0' && ISLDZDZB === 'Y'"
                      >
                        <van-tag type="primary" @click="editorCyHandler(item)"
                          >编辑</van-tag
                        >
                      </div>
                    </van-checkbox>
                  </div>
                </van-grid-item>

                <van-grid-item
                  @click="navToAddRyUrl()"
                  v-if="ISSF === '0' && ISLDZDZB === 'Y'"
                >
                  <img src="../../assets/images/add.png" style="width:30px" />
                </van-grid-item>
              </van-grid>
            </van-checkbox-group>
          </div>
        </div>

        <!-- 女生数量  结束 -->

        <div style="height:150px;width:15px;"></div>
      </div>
    </van-action-sheet>
    <!-- 已有的队员弹出框  结束 -->

    <!-- 选择组别弹出框  开始 -->
    <van-action-sheet v-model="zbShowVisible" title="分配组别">
      <div style="background: #F2F2F2;">
        <change-xm
          :ISBMRCOUNT="ISBMRCOUNT"
          :ssid="ssid"
          :resultXmList="resultXmList"
          :sslxList="sslxList"
          :utilPost="utilPost"
          :reportLx="'CJMDBM'"
          :isLd="'0'"
          bmLx="TEAM"
          :dwid="DWID"
          :czlx="czlx"
          checkBmrsLx="ALLCHECK"
        ></change-xm>
        <div style="height:100px;width:15px;"></div>
      </div>
    </van-action-sheet>
    <!-- 选择组别弹出框  结束 -->
    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
import ChangeXm from "../commonCom/ChangeXm.vue";
export default {
  name: "DyGl",
  components: { ChangeXm, LoadingCom },
  data() {
    return {
      BSLXR: "",
      BSLXRTEL: "",
      selectRyidCheckBoxDatas: [],
      dwGlShowVisible: false,
      zbShowVisible: false,
      activeNames: ["1"],
      utilPost: "",
      ssid: "",
      DWID: "",
      SSMC: "",
      ZRS: "",
      ZBCOUNT: "",
      DWXX: {},
      MRYLIST: [],
      WRYLIST: [],
      resultXmList: [],
      sslxList: [],
      czlx: "",
      ISSF: "0",
      ISBMRCOUNT: 0,
      routeValue: "",
      ISLDZDZB: "N"
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.DWID = this.$route.query.DWID;
    this.czlx = this.$route.query.czlx;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
    this.mainData();
    this.getXmData();
  },
  methods: {
    getXmData() {
      //获取比赛项目
      var busData = {
        czlx: this.czlx,
        dwid: this.DWID,
        bmLx: "TEAM",
        isLoadDtInfo: "0",
        isLoadRyCount: "1"
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getXmData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.resultXmList = data.content.resultXmList;
        this.sslxList = data.content.sslxList;
        this.ISBMRCOUNT = data.content.ISBMRCOUNT;
      });
    },
    onTopClickLeft() {
      this.$router.go(-1);
    },
    onTopClickRight() {
      this.isWriteShow = true;
    },
    mainData() {
      var busData = {
        DWID: this.DWID
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "dyGl" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.SSMC = data.content.SSMC;
        this.DWXX = data.content.DWXX;
        var arrayLdxm = this.DWXX.LDXM.split("&");
        var arrayLdtel = this.DWXX.LDTEL.split("&");
        this.DWXX.LDXM = arrayLdxm[0];
        this.DWXX.LDTEL = arrayLdtel[0];
        this.BSLXR = arrayLdxm[1];
        this.BSLXRTEL = arrayLdtel[1];
        this.ZBCOUNT = data.content.ZBCOUNT;
        this.ZRS = data.content.ZRS;
        this.ISSF = data.content.ISSF;
        this.ISLDZDZB = data.content.ISLDZDZB;
      });
    },
    openDyInfoHandler() {
      var busData = {
        DWID: this.DWID
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getTeramRyxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.dwGlShowVisible = true;
        this.MRYLIST = data.content.MRYLIST;
        this.WRYLIST = data.content.WRYLIST;
      });
    },
    //选择组别弹出框
    openZbShowHandler() {
      this.zbShowVisible = true;
    },
    //跳转
    navToAddRyUrl(navType) {
      this.$router.push({
        path: "/addRyInfo",
        query: {
          ssid: this.ssid,
          xmid: "",
          bmLx: "TEAM",
          dwid: this.DWID,
          czlx: "ADD",
          isTeamSelect: "1"
        }
      });
    },
    //删除成员信息
    teamDeleteCyxx() {
      if (!confirm("是否删除？")) {
        return;
      }
      var busData = {
        DWID: this.DWID,
        delList: this.selectRyidCheckBoxDatas
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "teamDeleteCyxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);

        if (data.isSuccess) {
          this.dwGlShowVisible = false;
          this.mainData();
        }
      });
    },
    copyUrl() {
      // const oInp{ut = this.$refs.copyInput[0] // 无效
      // const oInput = document.getElementById('copyInput') //无效
      const oInput = document.createElement("input");
      // 这边为链接地址this.liveLink='www.baidu.com'
      oInput.value =
        "https://www.ptty.com.cn/wap/#/addRyInfo?ssid=" +
        this.ssid +
        "&xmid=&bmLx=TEAM&dwid=" +
        this.DWID +
        "&czlx=" +
        this.czlx +
        "&isCyWrite=1";
      document.body.appendChild(oInput);
      oInput.select();
      console.log(oInput.value);
      document.execCommand("Copy");
      oInput.remove();
      alert("复制成功");
    },
    editorCyHandler(row) {
      this.$router.push({
        path: "/addRyInfo",
        query: {
          ssid: this.ssid,
          xmid: "",
          bmLx: "TEAM",
          dwid: this.DWID,
          czlx: "UPT",
          ryid1Param: row.RYID,
          ryid2Param: "",
          isTeamSelect: "1"
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.van-button--warning,
.van-button--primary {
  width: 130px;
  height: 35px;
}
/deep/ .van-checkbox__icon--round {
  position: absolute;
  top: 0px;
  left: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportXm/DyGl.vue